import * as types from './actionTypes';
import preferencesApi from '../api/preferencesApi';

export function loadPreferencesSuccess(preferences) {
  return {type: types.LOAD_PREFERENCES_SUCCESS, preferences};
}

export function loadPreferences(deviceId, authToken) {  
  return function(dispatch) {
    return preferencesApi.getPreferences(deviceId, authToken).then(preferences => {
      dispatch(loadPreferencesSuccess(preferences));
    }).catch(error => {
      throw(error);
    });
  };
}

export function updatePreferencesSuccess(preferences) {
  return {type: types.UPDATE_PREFERENCES_SUCCESS, preferences};
}

export function updatePreferences(deviceId, authToken, preferences) {  
  return function(dispatch) {
    return preferencesApi.updatePreferences(deviceId, authToken, preferences).then(responsePreference => {
      dispatch(updatePreferencesSuccess(responsePreference));
	  return responsePreference;
    }).catch(error => {
      throw(error);
    });
  };
}




// WEBPACK FOOTER //
// ./src/actions/preferencesActions.js